import * as actionTypes from "../constants/categoryConstants";
import axios from "axios";
import { URL } from "../../App";

export const getCategories = () => async (dispatch) => {
    const { data } = await axios.get(`${URL}/api/categories`);
    dispatch({
        type: actionTypes.GET_CATEGORIES_REQUEST,
        payload: data,
    })
}